import { SelectedGradeState } from '../reducers/SelectedGradeReducer';

export enum SelectedGradeActionType {
    SET_SELECTED_GRADE = 'SET_SELECTED_GRADE',
}

interface SetSelectedGradeActionType {
    type: SelectedGradeActionType.SET_SELECTED_GRADE;
    payload: SelectedGradeState;
}

export type SelectedGradeAction = SetSelectedGradeActionType;
